<template>
  <div id="app">
    <div class="content">
      <router-view/>
    </div>
    <div class="footer-bar" :class="{goodBabyShowing}" v-observe-visibility="showTheGoodBaby"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility);

export default {
  data(){
    return {
      goodBabyShowing: false
    }
  },
  methods:{
    showTheGoodBaby(e) {
      this.goodBabyShowing = e;
    }
  }
}



</script>

<style lang="scss">
$break-small: 765px;

body {
  margin: 0;
  overflow: scroll;
  overflow-x: hidden;
}

* {
  box-sizing: border-box;
}

#app {
  max-width: 960px;
  margin: 0 auto;
  padding: 0px 40px;
  font-family: sans-serif;
  text-align: center;
  font-size: 16px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
    @media screen and (max-width: $break-small) {
    padding: 0 5%;
  }
}

.content {
  flex-grow: 1;
}

h1, h2, h3, h4, h5 {
  font-family: 'Raleway', sans-serif;
}

h3 {
  letter-spacing: .06em;
}

.footer-bar {
  background-image:url('./assets/baby.png');
  height: 48px;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  background-position: center;
  margin-top: 100px;
  transform: translateY(100%);
  transition: transform 0.5s;
  overflow: hidden;

  &.goodBabyShowing {
    transform: translateY(0%);
  }
}

</style>
